module.exports = __webpack_public_path__ + "media/src/images/apple-icon-76x76-5eba9e4701539c7efbd623b9072dd983.png";